export default "__VITE_ASSET__DwtHPQkT__"